import Breadcrumb, { type Crumb } from '@/components/base/Breadcrumb';

interface PageHeaderProps {
  title: string;
  subtitle: string;
  crumbs: Crumb[];
  icon?: string;
}

export default function PageHeader({ title, subtitle, crumbs, icon }: PageHeaderProps) {
  return (
    <section className="w-full bg-background-100 border-b border-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-8 md:py-12">
        <Breadcrumb items={crumbs} />
        <div className="flex items-start gap-3">
          {icon ? (
            <span className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 shrink-0">
              <i className={`${icon} text-xl md:text-2xl`} />
            </span>
          ) : null}
          <div>
            <h1 className="font-heading text-2xl md:text-4xl text-foreground-950 leading-tight">{title}</h1>
            <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-2xl">{subtitle}</p>
          </div>
        </div>
      </div>
    </section>
  );
}